module.exports = __webpack_public_path__ + "img/meat-full.1d34ded5.png";